module.exports = __webpack_public_path__ + "static/media/sun-glasses-7.8392fc63.jpg";